import { Box, Container, Typography } from '@material-ui/core';
import React, { memo, useEffect } from 'react';
import useOrgAdmins from 'src/hooks/useOrgAdmins';
import SearchField from '../../../components/SearchField/SearchField';
import OrgAdminTable from '../../OrgAdminTable/OrgAdminTable';
import { useOrgDetailsStyles } from './styles';
interface OrgDetailsProps {
  orgId: string;
}
const OrgDetails: React.FC<OrgDetailsProps> = ({ orgId }) => {
  const classes = useOrgDetailsStyles();
  const { searchQuery, updateSearchQuery } = useOrgAdmins();
  useEffect(() => () => updateSearchQuery(''), []);
  return (
    <Container disableGutters maxWidth="xl">
      <Typography
        variant="h5"
        className={classes.title}
        data-testid="adminList-title"
      >
        User management
      </Typography>
      <Typography
        variant="body1"
        className={classes.description}
        data-testid="adminList-subtitle"
      >
        People that can manage users in your organisation.
      </Typography>
      <Box className={classes.searchField}>
        <SearchField
          searchQuery={searchQuery}
          placeholder="e.g. Jane Smith"
          onSubmit={updateSearchQuery}
          onChange={updateSearchQuery}
        />
      </Box>
      <Box className={classes.table}>
        <OrgAdminTable orgId={orgId} />
      </Box>
    </Container>
  );
};

export default memo(OrgDetails);
